import React from 'react'
import EditEmailCampaign from '../../features/emailManagement/component/editEmailCampaign'

function EditEmailCampaigns() {
    return (
        <EditEmailCampaign />
    )
}
export default EditEmailCampaign